import { apiFetch } from "./client";

/* ---------- Grants ---------- */

export interface GrantSummaryJob {
  id: string;
  status: string;
  created_at: string;
}

export interface GrantRecord {
  id: string;
  user_id: string;
  agent_id: string;
  scope_type: string;
  scope_value: string;
  status: string;
  expires_at: string | null;
  created_at: string;
  summary_jobs?: GrantSummaryJob[];
}

interface GrantListParams {
  user_id?: string;
  agent_id?: string;
  scope_type?: string;
  status?: string;
  page?: number;
  per_page?: number;
}

interface GrantListResponse {
  items: GrantRecord[];
  total: number;
}

export async function fetchGrants(
  params: GrantListParams,
): Promise<GrantListResponse> {
  const qs = buildQuery(params);
  const res = await apiFetch<{ data: GrantListResponse }>(`/admin/grants${qs}`);
  return res.data;
}

export async function fetchGrantDetail(id: string): Promise<GrantRecord> {
  const res = await apiFetch<{ data: GrantRecord }>(`/admin/grants/${id}`);
  return res.data;
}

/* ---------- Audit ---------- */

export interface AuditRecord {
  id: string;
  action: string;
  actor_id: string;
  target_id: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
}

interface AuditListParams {
  action?: string;
  actor_id?: string;
  target_id?: string;
  start_date?: string;
  end_date?: string;
  page?: number;
  per_page?: number;
}

interface AuditListResponse {
  items: AuditRecord[];
  total: number;
}

export async function fetchAuditRecords(
  params: AuditListParams,
): Promise<AuditListResponse> {
  const qs = buildQuery(params);
  const res = await apiFetch<{ data: AuditListResponse }>(`/admin/audit${qs}`);
  return res.data;
}

/* ---------- Helpers ---------- */

function buildQuery(params: GrantListParams | AuditListParams): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== "") {
      sp.set(k, String(v));
    }
  }
  const str = sp.toString();
  return str ? `?${str}` : "";
}
